import React, {Component} from 'react';
import FavouriteAPI from "../classes/FavouriteAPI";

class FavouriteCounter extends Component {

  constructor(props) {
    super(props);
    this.state = {count: 0};
    this.favouriteAPI = new FavouriteAPI();

    this.updateCount = this.updateCount.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  handleUpdate(event) {
    this.favouriteAPI.countFavourites().then((result) => this.updateCount(result.count));
  }

  updateCount(count) {
    this.setState({count: count});
  }

  componentDidMount() {
    this.handleUpdate();
    window.addEventListener('update-counter', this.handleUpdate);
  }

  componentWillUnmount() {
    window.removeEventListener('update-counter', this.handleUpdate);
  }

  render() {
    if (this.state.count > 0) {
      return (
        <span className="header-favourites__count js-favourites__count header-favourites__count--active">{this.state.count}</span>
      );
    } else {
      return (<></>);
    }
  }
}

export default FavouriteCounter;
